import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isAuthenticated, isInitialAuthDone } from 'features/Auth/selectors';
import { hasPreferredLanguage } from '../selectors';
import { LanguageSelectionModal } from './LanguageSelectionModal';
import { updateLanguagePreference } from '../actions';
import type { Language } from 'utils/languages';

export const LanguageSelectionModalTrigger: React.FC = () => {
  const dispatch = useDispatch();
  const isUserAuthenticated = useSelector(isAuthenticated);
  const isAuthInitDone = useSelector(isInitialAuthDone);
  const userHasPreferredLanguage = useSelector(hasPreferredLanguage);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (!isAuthInitDone || !isUserAuthenticated) {
      setIsModalOpen(false);
      return;
    }

    if (userHasPreferredLanguage) {
      setIsModalOpen(false);
      return;
    }

    const timer = setTimeout(() => {
      setIsModalOpen(true);
    }, 2000); // 2s delay — long enough to cover most network latency

    return () => clearTimeout(timer);
  }, [isAuthInitDone, isUserAuthenticated, userHasPreferredLanguage]);

  const handleLanguageSelect = (language: Language) => {
    dispatch(updateLanguagePreference({ languageCode: language.code }));
    setIsModalOpen(false);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  return (
    <LanguageSelectionModal
      isOpen={isModalOpen}
      onLanguageSelect={handleLanguageSelect}
      onClose={handleClose}
    />
  );
};